import { render, staticRenderFns } from "./CourseEffectsModal.vue?vue&type=template&id=514a8d24&scoped=true&"
import script from "./CourseEffectsModal.vue?vue&type=script&lang=js&"
export * from "./CourseEffectsModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseEffectsModal.vue?vue&type=style&index=0&id=514a8d24&scoped=true&lang=scss&"
import style1 from "./CourseEffectsModal.vue?vue&type=style&index=1&id=514a8d24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a8d24",
  null
  
)

export default component.exports